export default "__VITE_ASSET__1218fe79__"